import { Image as ImageIcon, Video, Mic, File as FileIcon } from 'lucide-react';

export const TYPE_ICONS = { photo: ImageIcon, video: Video, voice: Mic, document: FileIcon };
export const LANGUAGES = ['English', 'French', 'Spanish', 'German', 'Italian'];

export const fmtDateFR = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
};

export const fmtDateTimeFR = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  return `${fmtDateFR(iso)} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};

export const daysSince = (iso) =>
  iso ? Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 86400000)) : null;

// Native Telegram presence text, mirroring exactly what the official app shows.
export const tgStatus = (c) => {
  if (c.online) return { text: 'Online', online: true };
  if (c.status_class === 'exact' && c.last_seen_at) {
    const d = new Date(c.last_seen_at);
    const mins = Math.floor((Date.now() - d.getTime()) / 60000);
    if (mins < 1) return { text: 'Last seen just now' };
    if (mins < 60) return { text: `Last seen ${mins} min ago` };
    const hhmm = `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    const now = new Date();
    if (d.toDateString() === now.toDateString()) return { text: `Last seen at ${hhmm}` };
    const yesterday = new Date(now.getTime() - 86400000);
    if (d.toDateString() === yesterday.toDateString()) return { text: `Last seen yesterday at ${hhmm}` };
    return { text: `Last seen ${fmtDateFR(c.last_seen_at)}` };
  }
  if (c.status_class === 'recently') return { text: 'Last seen recently' };
  if (c.status_class === 'last_week') return { text: 'Last seen within a week' };
  if (c.status_class === 'last_month') return { text: 'Last seen within a month' };
  if (c.status_class === 'hidden') return { text: 'Last seen a long time ago' };
  return { text: 'Last seen recently' };
};
